import { render, staticRenderFns } from "./MainFormReset.vue?vue&type=template&id=59c93722&"
import script from "./MainFormReset.vue?vue&type=script&lang=js&"
export * from "./MainFormReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports